"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const notificationsToolRegistry = {
  notifyUser: {
    kind: "step",
    category: "message",
    view: lazy(() =>
      import("./notify-user").then(({ NotifyUserToolView }) => ({
        default: NotifyUserToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
